<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.75 0.5C11.3023 0.5 11.75 0.94772 11.75 1.5V5.5H12.75C12.8175 5.5 12.884 5.49998 12.9496 5.49996C14.6186 5.49952 15.698 5.49924 16.6041 5.79366C18.4308 6.38717 19.8629 7.81927 20.4564 9.6459C20.7508 10.552 20.7505 11.6314 20.7501 13.3004C20.7501 13.366 20.75 13.4325 20.75 13.5C20.75 13.5675 20.7501 13.634 20.7501 13.6996C20.7505 15.3686 20.7508 16.448 20.4564 17.3541C19.8629 19.1807 18.4308 20.6128 16.6041 21.2063C15.698 21.5008 14.6186 21.5005 12.9496 21.5C12.884 21.5 12.8175 21.5 12.75 21.5H8.75007C8.68261 21.5 8.61609 21.5 8.55048 21.5C6.88149 21.5005 5.80211 21.5008 4.89596 21.2063C3.06934 20.6128 1.63723 19.1807 1.04373 17.3541C0.749303 16.448 0.749593 15.3686 0.750033 13.6996C0.750053 13.634 0.750073 13.5675 0.750073 13.5C0.750073 13.4325 0.750053 13.366 0.750033 13.3004C0.749593 11.6314 0.749303 10.552 1.04373 9.6459C1.63723 7.81927 3.06934 6.38717 4.89596 5.79366C5.80211 5.49924 6.8815 5.49952 8.5505 5.49996C8.6161 5.49998 8.68262 5.5 8.75007 5.5H9.75002V1.5C9.75002 0.94772 10.1978 0.5 10.75 0.5ZM8.75007 7.5C6.81095 7.5 6.07856 7.51234 5.514 7.69577C4.29625 8.09145 3.34151 9.04618 2.94584 10.2639C2.7624 10.8285 2.75007 11.5609 2.75007 13.5C2.75007 15.4391 2.7624 16.1715 2.94584 16.7361C3.34151 17.9538 4.29625 18.9086 5.514 19.3042C6.07856 19.4877 6.81095 19.5 8.75007 19.5H12.75C14.6892 19.5 15.4216 19.4877 15.9861 19.3042C17.2039 18.9086 18.1586 17.9538 18.5543 16.7361C18.7377 16.1715 18.75 15.4391 18.75 13.5C18.75 11.5609 18.7377 10.8285 18.5543 10.2639C18.1586 9.04618 17.2039 8.09145 15.9861 7.69577C15.4216 7.51234 14.6892 7.5 12.75 7.5H8.75007ZM5.75007 12.5C5.75007 11.3954 6.6455 10.5 7.75007 10.5C8.85462 10.5 9.75002 11.3954 9.75002 12.5C9.75002 13.6046 8.85462 14.5 7.75007 14.5C6.6455 14.5 5.75007 13.6046 5.75007 12.5ZM11.75 12.5C11.75 11.3954 12.6455 10.5 13.75 10.5C14.8546 10.5 15.75 11.3954 15.75 12.5C15.75 13.6046 14.8546 14.5 13.75 14.5C12.6455 14.5 11.75 13.6046 11.75 12.5Z"
      :fill="iconColor"/>
  </svg>


</template>

<script>
  export default {
    props: {
      iconName: {
        type: String,
        default: 'iconAiAgent'
      },
      width: {
        type: [Number, String],
        default: 22
      },
      height: {
        type: [Number, String],
        default: 22
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  }
</script>